<ng-template #notaControlCPPCModal let-modal="close">
  <div class="modal-header">
    <h3 class="modal-title">Notă control CPPC</h3>

    <div class="col-sm-12 col-md-12 col-lg-6 text-right custom-col">
      <div class="btn-group custom-modal-btn">
        <button
          class="btn btn-sm btn-secondary"
          (click)="modal('Cross click')"
          autofocus="false"
        >
          Închide
        </button>

        <button
          *ngIf="isSuperAdmin || (!readonly && (isAdmin || isOperator))"
          class="btn btn-sm btn-success"
          (click)="onSubmitted()"
        >
          Salvează
        </button>
      </div>
    </div>
  </div>

  <div class="modal-body">
    <div class="container-fluid">
      <form [formGroup]="notaControlCPPCForm">
        <div class="row">
          <div class="col-sm-12 col-lg-auto">
            <div class="form-group mb-3 mr-3">
              <label>Data</label>
              <app-date-picker
                [selectedDate]="notaControlCPPCForm.controls.data.value"
                (dateChanged)="onDataChanged($event)"
                [disabled]="
                  !(isSuperAdmin || (!readonly && (isAdmin || isOperator)))
                "
              ></app-date-picker>
            </div>
          </div>

          <div class="col-sm-12 col-lg-auto">
            <div class="form-group mb-3">
              <label for="numar">Număr</label>
              <input
                type="text"
                formControlName="numar"
                class="form-control"
                [readonly]="
                  !(isSuperAdmin || (!readonly && (isAdmin || isOperator)))
                "
              />
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-xl-9">
            <div class="form-group mb-3">
              <label for="operator_id">Operator control</label>
              <ng-select
                [items]="operatori"
                bindLabel="full_name"
                bindValue="id"
                formControlName="operator_id"
                placeholder="Alege operatorul"
                [ngClass]="{
                  disabled: !(
                    isSuperAdmin ||
                    (!readonly && (isAdmin || isOperator))
                  )
                }"
              >
              </ng-select>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-12 mb-3">
            <label class="d-inline-flex align-self-center mb-0 mr-3">
              Fișier
            </label>

            <app-upload-fisier
              *ngIf="!notaControlCPPCForm.value.file_id"
              class="mr-3"
              (ApiResponse)="uploadServerResponse($event)"
            >
            </app-upload-fisier>

            <span *ngIf="fileName">
              <span
                class="file-button"
                (click)="downloadFile($event)"
              >
                {{ fileName }}
              </span>

              <button
                *ngIf="isSuperAdmin || (!readonly && (isAdmin || isOperator))"
                type="button"
                class="btn btn-lg p-0 ml-2 mdi mdi-delete text-danger"
                ngbTooltip="Șterge fișier"
                placement="right"
                (click)="deleteFile()"
              ></button>
            </span>
          </div>
        </div>
      </form>
    </div>
  </div>
</ng-template>
